/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscriptionlimitreached2Inputs */

const en_subscriptionlimitreached2 = /** @type {(inputs: Subscriptionlimitreached2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You've reached your plan's limit. Upgrade to continue.`)
};

const de_subscriptionlimitreached2 = /** @type {(inputs: Subscriptionlimitreached2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast das Limit deines Plans erreicht. Wechsle deinen Plan, um weiterzumachen.`)
};

/**
* | output |
* | --- |
* | "You've reached your plan's limit. Upgrade to continue." |
*
* @param {Subscriptionlimitreached2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const subscriptionlimitreached2 = /** @type {((inputs?: Subscriptionlimitreached2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscriptionlimitreached2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscriptionlimitreached2(inputs)
	return de_subscriptionlimitreached2(inputs)
});
export { subscriptionlimitreached2 as "subscriptionLimitReached" }